var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceMailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    stroke: "#8180F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00157 19.0892C9.03994 18.8921 9.07282 18.6895 9.11666 18.4925C9.59343 16.4231 11.4896 14.945 13.594 14.9998C15.7477 15.06 17.5671 16.6038 17.9288 18.7169C18.1589 20.0527 17.8301 21.2625 16.9807 22.3246C16.9423 22.3684 16.9095 22.4176 16.8547 22.4833C18.6247 22.4833 20.3729 22.4833 22.143 22.4833C22.0992 22.4286 22.0663 22.3793 22.0334 22.3355C20.9703 20.9779 20.6963 19.4724 21.321 17.8739C21.9567 16.2589 23.1842 15.3063 24.905 15.0545C27.3273 14.6987 29.618 16.4395 29.9577 18.8483C30.303 21.2844 28.648 23.5563 26.2422 23.9341C25.9682 23.9779 25.6832 23.9998 25.4037 24.0052C21.469 24.0107 17.5287 24.0107 13.594 24.0052C11.38 24.0052 9.58247 22.5764 9.10022 20.4523C9.06186 20.2771 9.03445 20.0965 8.99609 19.9158C9.00157 19.6366 9.00157 19.3629 9.00157 19.0892ZM28.5 19.4943C28.4945 17.8355 27.1574 16.4998 25.4969 16.5052C23.8419 16.5052 22.4992 17.852 22.4992 19.5052C22.4992 21.153 23.8473 22.4943 25.5078 22.4943C27.1628 22.4943 28.5055 21.1476 28.5 19.4943ZM10.5031 19.5052C10.5086 21.164 11.8458 22.4943 13.5063 22.4943C15.1613 22.4888 16.5039 21.1421 16.5039 19.4943C16.4984 17.841 15.1503 16.5052 13.4953 16.5052C11.8403 16.5052 10.4977 17.852 10.5031 19.5052Z",
    fill: "#8B8BE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 9,
    fill: "white",
    transform: "translate(9 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceMailsIcon);
export default __webpack_public_path__ + "static/media/voice-mails-icon.8816ca23f53f3b97c252a32c3aca6870.svg";
export { ForwardRef as ReactComponent };